import React from 'react';
import PropTypes from 'prop-types';
import { useAtom } from 'jotai';
import {
  staticDataAtom,
  cookiesAtom,
  displayClearCookiesAtom,
  cookiesDeletedAtom,
  listTicketsAtom,
} from 'Atoms/Common';
import { ticketAtom } from 'Atoms/Ticket';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
import { TrashIcon } from 'images/svg';
import { ButtonActions } from 'Components/UI';
import { Link, useHistory } from 'react-router-dom';
import { postRenewCookie } from 'utils';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.containerGrid,
    height: '100%',
    top: 0,
    position: 'fixed',
    marginTop: 0,
    backgroundColor: 'rgba(38, 41, 87, 0.1)',
  },
  clearCookies: {
    padding: '1rem 1.5rem',
    height: '65%',
    bottom: 0,
    position: 'fixed',
    backgroundColor: '#fff',
    borderRadius: '30px 30px 0 0',
    textAlign: 'center',
  },
  title: theme.title,
  warning: {
    color: theme.palette.secondary.main,
  },
  icon: {
    '& svg': {
      width: '51px',
      height: '67px',
      fill: theme.palette.secondary.main,
    },
  },
  warningContainer: {
    padding: '1.3rem',
  },
}));

const ClearCookies = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();

  const [, setCookies] = useAtom(cookiesAtom);
  const [, setDisplayClearCookies] = useAtom(displayClearCookiesAtom);
  const [, setCookiesDeleted] = useAtom(cookiesDeletedAtom);
  const [, setListTickets] = useAtom(listTicketsAtom);
  const [staticData] = useAtom(staticDataAtom);
  const [ticket] = useAtom(ticketAtom);

  const handleCookies = (e) => {
    e.preventDefault();
    renewCookie();
  };

  const renewCookie = async () => {
    const ticketAlias = ticket?.id;
    const idSession = staticData?.idSession;
    const resulatRenewCookie = await postRenewCookie(ticketAlias, idSession);
    setCookies(resulatRenewCookie);
    setCookiesDeleted(true);
    history.go(0);
  };

  return (
    <Grid container className={classes.root}>
      <Grid
        container
        className={classes.clearCookies}
        direction="column"
        alignContent="center"
        alignItems="center"
        justifyContent="space-evenly"
      >
        <Grid item className={classes.icon}>
          <TrashIcon />
        </Grid>
        <Grid item>
          <Typography className={classes.title}>
            {t('clear_cookies')}
          </Typography>
          <Typography className={classes.warningContainer}>
            <Trans>
              {t('warning_clear_cookies')}
              <span
                className={classes.warning}
                title={t('permanent_deletion')}
              ></span>
            </Trans>
          </Typography>
        </Grid>
        <Grid item>
          <Link to={{}} onClick={(e) => handleCookies(e)}>
            <ButtonActions
              label={t('delete_tickets')}
              styles={{
                label: 'labelWhite',
                radius: 'radius33',
              }}
              color="secondary"
            />
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
};

ClearCookies.propTypes = {};

export default ClearCookies;
